export const ClientPortalLogicTypeEnum = {
  display: 'display',
  required: 'required',
  prevent_submit: 'prevent_submit',
  read_only: 'read_only',
} as const;
export type ClientPortalLogicTypeEnum =
  (typeof ClientPortalLogicTypeEnum)[keyof typeof ClientPortalLogicTypeEnum];
